"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeProps = exports.useSharedState = exports.indexErrorMessage = void 0;
var guid_typescript_1 = require("guid-typescript");
var StackTrace = require("stacktrace-js");
var ts_functional_1 = require("ts-functional");
var useGlobal_1 = require("./useGlobal");
var inject_1 = require("./inject");
Object.defineProperty(exports, "inject", { enumerable: true, get: function () { return inject_1.inject; } });
var useDerivedState_1 = require("./useDerivedState");
Object.defineProperty(exports, "useDerivedState", { enumerable: true, get: function () { return useDerivedState_1.useDerivedState; } });
var useGlobal_2 = require("./useGlobal");
Object.defineProperty(exports, "useGlobal", { enumerable: true, get: function () { return useGlobal_2.useGlobal; } });
var useLocalStorage_1 = require("./useLocalStorage");
Object.defineProperty(exports, "useLocalStorage", { enumerable: true, get: function () { return useLocalStorage_1.useLocalStorage; } });
exports.indexErrorMessage = "Unstateless error:  An index is required when using useSharedState directly inside a component.";
exports.useSharedState = function (initialValue, i) {
    var isRendering = StackTrace.getSync().filter(function (s) { return s.functionName === "renderWithHooks"; }).length > 0;
    if (isRendering && typeof i === "undefined") {
        throw exports.indexErrorMessage;
    }
    var initial = (!!i ? i : initialValue);
    var index = (!!i ? initialValue : guid_typescript_1.Guid.create().toString());
    var f = useGlobal_1.addSharedState(index, function () { return useGlobal_1.useGlobal()(index, initial); });
    return f;
};
exports.mergeProps = ts_functional_1.pipe;
